// src/Components/Highlights.js (or ComplaintsTab.js)
import React, { useEffect, useState } from 'react';
import '../CSS/Highlights.css';

const REPORT_TYPE = 'Complaints'; // what gets written to SharePoint

function logComplaintClick(reportName, reportType = REPORT_TYPE) {
  const userEmail = localStorage.getItem('user-email');
  if (!userEmail) return;

  const payload = { reportName, reportType, userEmail };

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon('/api/log-report', blob);
    } else {
      fetch('/api/log-report', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify(payload),
      }).catch(() => {});
    }
  } catch {
    // swallow any logging errors
  }
}

const Highlights = () => {
  const [complaints, setComplaints] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Build proxy URLs for each item
  const addProxyUrls = (items) =>
    (items || []).map((item) => ({
      ...item,
      proxyUrl: `/api/highlights/Complaints/${encodeURIComponent(item.name)}.pdf`,
    }));

  useEffect(() => {
    let mounted = true;

    fetch('/api/hello')
      .then((r) => r.json())
      .then((data) => {
        if (!mounted) return;
        const complaintsWithProxy = addProxyUrls(data.Complaints);
        setComplaints(complaintsWithProxy);
        setFilteredData(complaintsWithProxy);
      })
      .catch((err) => console.error('Error fetching reports data:', err))
      .finally(() => mounted && setLoading(false));

    return () => {
      mounted = false;
    };
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim()) {
      const t = term.toLowerCase();
      setFilteredData(complaints.filter((item) => item.name?.toLowerCase().includes(t)));
    } else {
      setFilteredData(complaints);
    }
  };

  if (loading) {
    return (
      <div className="highlights power-bi complaints-wrapper">
        <h2>Activist Complaints</h2>
        <p>Loading…</p>
      </div>
    );
  }

  return (
    <div className="highlights power-bi">
      <h2>Activist Complaints</h2>

      <div className="box">
        <p>
          An extensive compilation of formal complaints lodged by animal rights activists
          demanding punitive measures from regulatory agencies and/or targeted institutions
        </p>
      </div>

      {/* ✅ EXACT SAME SETUP AS THE OTHER PAGE (uses the same CSS) */}
      <label className="highlights-search">
        Search:&nbsp;
        <input
          type="text"
          placeholder="Search by title"
          value={searchTerm}
          onChange={handleSearch}
        />
      </label>

      <div className="complaints-scroll">
        <ul className="list-item">
          {filteredData.map((item, index) => (
            <li key={item.id || index}>
              <a
                href={item.proxyUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  const cleanName = (item.name || '').replace(/\.pdf$/i, '');
                  logComplaintClick(cleanName);
                }}
              >
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {filteredData.length === 0 && <p>No complaints found.</p>}
    </div>
  );
};

export default Highlights;
